import { View } from 'react-native';
import { clsx } from 'clsx';
import { Props } from 'shared/@types';
import { FaIcon, Icon } from 'shared/components/icon';
import { Text } from 'shared/components/text';
import { Tooltip } from 'shared/components/tooltip';

type ListingFeature = {
  title: string;
  icon: FaIcon;
  tooltip?: string;
};

export function ListingFeatureList({ items, className }: Props<{ items: ListingFeature[] }>) {
  return (
    <View className={clsx('flex-row flex-wrap gap-1.5', className)}>
      {items.map((item, index) => {
        const badge = (
          <View
            key={index}
            className={
              'border-brand-brown-dark/15 flex-row items-center gap-1.5 rounded-full border bg-white px-2 py-1'
            }
          >
            <Icon icon={item.icon} className={'text-brand-brown size-3.5'} />
            <Text className={'text-brand-brown-dark text-xs'}>{item.title}</Text>
          </View>
        );

        return item.tooltip ? (
          <Tooltip key={index} content={item.tooltip}>
            {badge}
          </Tooltip>
        ) : (
          badge
        );
      })}
    </View>
  );
}
